import { Component, OnInit } from '@angular/core';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { DataService } from 'src/app/services/data.service';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';

@Component({
  selector: 'app-loginassuppliercontext',
  templateUrl: './loginassuppliercontext.component.html',
  styleUrls: ['./loginassuppliercontext.component.scss']
})
export class loginassuppliercontextComponent extends BasePage implements OnInit {

  constructor(
    private appGlobalDataService: AppGlobalDataService,
    private dataService: DataService,
    logger: NGXLogger,
    appSettings: AppSettings,
    localstorageService: LocalstorageService,
    ) {
      super(localstorageService, logger, appSettings);
    }
  locStorage = Constants.localStorageKeys;
  supplierCode = '';
  supplierName = '';
  suppplierDisplayName = null;

  ngOnInit() {
    this.appGlobalDataService.loginAs.subscribe(data => {
      this.suppplierDisplayName = null;
      if (data != null) {
        this.supplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode);
          if (this.supplierCode) {
          this.dataService.getSupplier(this.supplierCode).subscribe((response: any) => {
            if (response != null) {
            this.supplierName = response.Data[0].SupplierName;
            this.suppplierDisplayName = this.supplierName + ' (' + this.supplierCode + ')';
            }
          });
        }
      }
  });
  }

  getSupplierNameForDisplay() {
    if (this.suppplierDisplayName && this.suppplierDisplayName.length > 8) {
      return this.suppplierDisplayName;
    } else {
      return this.supplierCode;
    }
  }
  getIsLoggedInAsSupplier() {
    this.setFlags();
    return this.IsLoggedInAsSupplier;
  }

  getIsEmployee() {
    this.setFlags();
    return this.IsEmployee;
  }

}
